<template>
  <div>
    <div class="paymentContainer">
      <div :id="planId"></div>
    </div>
  </div>
</template>

<script>
var Lambda = require("aws-sdk/clients/lambda");

import UserQuotaService from "../service/userQuotaService";
import { Auth } from "./auth/cognito_auth";

export default {
  name: "paypal",
  props: ["planId", "invoiceable"],
  data: function() {
    return {
      details: {}
    };
  },
  methods: {
    renderPaypal() {
      var that = this;

      var payPalOrderLambda = new Lambda();
      var id_token = Auth.getIdToken();

      var lambdaParams = {
        FunctionName: process.env.VUE_APP_AWS_LAMBDA_PAYPAL_ARN,
        InvocationType: "RequestResponse"
      };

      var style = {
        layout: "horizontal",
        color: "white",
        shape: "pill",
        label: "paypal",
        height: 45,
        tagline: false
      };

      // eslint-disable-next-line
      paypal
        .Buttons({
          style,
          createOrder: function() {
            var promise = new Promise(function(resolve, reject) {
              lambdaParams.Payload = JSON.stringify({
                idToken: id_token,
                planId: that.planId.toUpperCase(),
                invoiceable: that.invoiceable
              });

              payPalOrderLambda.invoke(lambdaParams, function(error, data) {
                if (error) {
                  reject(that.$emit("on-payment-failure"));
                } else {
                  resolve(data);
                }
              });
            });

            return promise.then(function(data) {
              var order = JSON.parse(data.Payload);
              return order.orderId;
            });
          },
          onApprove: function(data, actions) {
            return actions.order.capture().then(function(details) {
              lambdaParams.Payload = JSON.stringify({
                idToken: id_token,
                orderId: details.id,
                invoiceable: that.invoiceable
              });

              payPalOrderLambda.invoke(lambdaParams, function(error) {
                if (error != null) {
                  that.$emit("on-payment-failure");
                  return;
                }

                that.$emit("on-payment-success");
                UserQuotaService.getUserCharactersLeft().then(function(
                  response
                ) {
                  that.$store.commit(
                    "setUserCharactersLeft",
                    response.data.charactersBalance
                  );
                });
              });
            });
          }
        })
        .render("#" + this.planId);
    }
  },
  mounted: function() {
    if (window.paypal) {
      this.renderPaypal();
    } else {
      var that = this;
      setTimeout(function() {
        that.renderPaypal();
      }, 5000);
    }
  }
};
</script>


